// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GuestVipTierCombobox__container___ZJOyN [data-testid='chip']{background-color:var(--gold)}.GuestVipTierCombobox__popup___cvo1W{min-width:16rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/components/guestVipTier/GuestVipTierCombobox/GuestVipTierCombobox.scss"],"names":[],"mappings":"AACE,8DACE,4BAAA,CAIJ,qCACE,eAAA","sourcesContent":[".container {\n  :global([data-testid='chip']) {\n    background-color: var(--gold);\n  }\n}\n\n.popup {\n  min-width: 16rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "GuestVipTierCombobox__container___ZJOyN",
	"popup": "GuestVipTierCombobox__popup___cvo1W"
};
export default ___CSS_LOADER_EXPORT___;
